import React from 'react';
import { marginTopHeader, narrowHeaderFooterMargins, normalHeaderFooterMargins } from '../margins';
import { EFontFamily, EMarginSize, getFontFamilyCss } from '../types';
import { style } from './ExportPdfHeaderStyle';

export type IExportPdfHeader = {
  primaryTitle: string;
  secondaryTitle: string;
  subtitle: string;
  marginSize: EMarginSize;
  showPrimaryTitle: boolean;
  showSecondaryTitle: boolean;
  showSubtitle: boolean;
  showNumberFormattingThousands: boolean;
  showHeader: boolean;
  numberFormattingThousandsLabel: string;
  showHeaderInAllPages: boolean;
  fontFamily: EFontFamily;
  continuationLabel: string;
  isContinuation?: boolean;
};

export const ExportPdfHeader: React.FC<IExportPdfHeader> = ({
  primaryTitle,
  secondaryTitle,
  subtitle,
  showPrimaryTitle,
  showSecondaryTitle,
  showSubtitle,
  showNumberFormattingThousands,
  marginSize,
  showHeader,
  numberFormattingThousandsLabel,
  showHeaderInAllPages,
  fontFamily,
  continuationLabel,
  isContinuation = false
}) => {
  const shouldShowSecondaryLine = showSecondaryTitle || isContinuation;
  let secondaryLineText = secondaryTitle;
  if (isContinuation) {
    secondaryLineText = showSecondaryTitle ? `${secondaryTitle} ${continuationLabel}` : continuationLabel;
  }

  return (
    <>
      {showHeader && (
        <header
          data-test="pdf-header-container"
          className="header"
          style={{
            fontFamily: getFontFamilyCss(fontFamily),
            textAlign: 'center',
            ...(marginSize === EMarginSize.narrow
              ? {
                  marginLeft: narrowHeaderFooterMargins['margin-left'],
                  marginRight: narrowHeaderFooterMargins['margin-right'],
                  ...(showHeaderInAllPages ? marginTopHeader.narrowMargins : {})
                }
              : {
                  marginLeft: normalHeaderFooterMargins['margin-left'],
                  marginRight: normalHeaderFooterMargins['margin-right'],
                  ...(showHeaderInAllPages ? marginTopHeader.normalMargins : {})
                }),
            padding: 0,
            margin: 'auto',
            ...(showHeaderInAllPages ? { transform: 'scale(0.78)' } : {})
          }}
        >
          {showPrimaryTitle && <h1 style={style.primaryTitle}>{primaryTitle}</h1>}
          {shouldShowSecondaryLine && <div style={style.secondaryTitle}>{secondaryLineText}</div>}
          {showSubtitle && <div style={style.subtitle}>{subtitle}</div>}
          {showNumberFormattingThousands && (
            <span style={style.numberFormattingThousandsLabel}>{numberFormattingThousandsLabel}</span>
          )}
        </header>
      )}
    </>
  );
};
